import type { FireflyRuntime, ModuleRegisterFunction } from "@squide/firefly";

export const registerSegments: ModuleRegisterFunction<FireflyRuntime> = async runtime => {
    if (runtime.isMswEnabled) {
        const { segmentsRequestHandler } = await import("./mocks/segmentsRequestHandler.ts");

        runtime.registerRequestHandlers([segmentsRequestHandler]);
    }
};
